import styled from 'styled-components';
import { TokenName } from '@mewssystems/design-tokens';
import { getToken } from '@optimus-web/common';

export const RadioGroupElement = styled.div`
    display: flex;
    flex-direction: column;
`;

export const RadioButtonGroupContainer = styled.span`
    display: inline-flex;
    flex-direction: column;
    margin: ${getToken(TokenName.SPACING_100)}px 0;
`;
